module.exports = __webpack_public_path__ + "img/type--3-spans--multiple-lang--es.18003ff0.jpg";